// extracted by mini-css-extract-plugin
module.exports = {"filterparam":"styles_filterparam__Pp-5k","title":"styles_title__3SDLD","priceWrap":"styles_priceWrap__3tuv8","price":"styles_price__9tPH_"};